export const FETCH_TASKS = 'FETCH_TASKS';
export const UPDATE_TASKS = 'UPDATE_TASKS';
export const FETCH_DATES = 'FETCH_DATES';
export const UPDATE_TODAY_TASKS = 'UPDATE_TODAY_TASKS';
export const UPDATE_YESTERDAY_TASKS = 'UPDATE_YESTERDAY_TASKS';
